import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "3.96vw"
        },
        card: {
            width: "100%",
            height: "30.5vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "0"
        },
        card: {
            width: "100%",
            height: "5.43vw",
            backgroundColor: Color.White
        }
    }
};


export const UserListLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    let loaderStyles = styles.mobile;
    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }
    const loaderElements = new Array<any>();
    const loaderElementsCount = 10;
    for (let i = 0; i < loaderElementsCount; i++) {
        loaderElements.push(
            <div key={i} style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <circle cx="13.36%" cy="41.80%" r="13.52%" />
                        <rect x="30.21%" y="10.3%" rx="3" ry="3" width="46.3%" height="17.25%"/>
                        <rect x="30.21%" y="32.74%" rx="3" ry="3" width="56.3%" height="10.08%"/>
                        <rect x="30.21%" y="46.74%" rx="3" ry="3" width="38.8%" height="10.08%"/>
                        <rect x="30.21%" y="61.13%" rx="10" ry="10" width="38.8%" height="20.78%"/>
                    </> :
                    <>
                        <circle cx="3.36%" cy="61.80%" r="3.52%" />
                        <rect x="8.45%" y="40.7%" rx="3" ry="3" width="16.9%" height="20.56%"/>
                        <rect x="8.45%" y="68.15%" rx="3" ry="3" width="12.9%" height="16.56%"/>
                        <rect x="45.45%" y="40.7%" rx="3" ry="3" width="13.9%" height="20.56%"/>
                        <rect x="45.45%" y="68.15%" rx="3" ry="3" width="23.85%" height="16.56%"/>
                        <rect x="81.36%" y="49.76%" rx="5" ry="5" width="13.09%" height="30.46%"/>
                    </>}                     
                </ContentLoader>
            </div>
        )
    }
    
    return (
        <div style={loaderStyles.wrapper}>
            {loaderElements}
        </div>
    );
}